import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  TextInput,
  TextInputIcon,
  Base,
  Button,
  Icon
} from '@brandwatch/axiom-components';
import store from '../../redux/store';

function updateSearchText(text) {
  store.dispatch({ type: 'UPDATE_SEARCH_TEXT', payload: text });
}

function handleOnChange(evt) {
  updateSearchText(evt.target.value);
}

const clearSearchText = updateSearchText.bind(null, '');

const SlidePickerSearch = ({ searchText, onRequestClose }) => {
  return (
    <React.Fragment>
      <Base className="FullscreenPanel__Search ax-theme--day">
        <TextInput
          placeholder="Search for slide"
          size="large"
          space="x0"
          onChange={handleOnChange}
          value={searchText}
          theme="day"
          onClear={clearSearchText}
        >
          <TextInputIcon align="left" name="magnify-glass" />
        </TextInput>
      </Base>
      <Base className="FullscreenPanel__Close">
        <Button
          shape="circle"
          onClick={onRequestClose}
          style="quaternary"
          theme="night"
        >
          <Icon name="cross" color="subtle" size="1.7rem" />
        </Button>
      </Base>
    </React.Fragment>
  );
};

SlidePickerSearch.propTypes = {
  searchText: PropTypes.string.isRequired,
  onRequestClose: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  searchText: state.search.searchText
});

export default connect(mapStateToProps)(SlidePickerSearch);
